import React from 'react';
import { NavCard } from '@components/simba-cards';
import { NavCardLink } from '@components/styled-link/StyledLink';
import { CenterProductsType } from '@appTypes/centerProductsType';
import S from '../styles';

export const ProductCard = ({
  product,
  path,
  isAvailable,
  alternateBackgroundColor,
}: {
  product: CenterProductsType;
  path: string;
  isAvailable: boolean;
  alternateBackgroundColor: boolean;
}) => (
  <>
    {isAvailable && product.isAvailable && product.link && (
      <S.ShortCutCol s="12" m="6" l="4" xl="4">
        <NavCardLink to={`/${path}/${product.link.data.slug}`}>
          <NavCard
            title={product.title}
            isInternalLink
            height="100%"
            variant={alternateBackgroundColor ? 'filled' : 'outline'}
            color="secondary"
            descriptionAs="div"
            description={
              <>
                {product.isCampaign && <S.StyledTag color="secondary" shade="light" text="Kampanje" />}
                {product.isForMembersOnly && <S.StyledTag color="primary" text="Medlemseksklusivt" />}
                {product.ingress}
              </>
            }
          />
        </NavCardLink>
      </S.ShortCutCol>
    )}
    {!isAvailable && !product.isAvailable && (
      <S.ShortCutCol s="12" m="6" l="4" xl="4">
        <NavCard
          disabled
          title={product.title}
          description={product.ingress}
          height="100%"
          variant={alternateBackgroundColor ? 'filled' : 'outline'}
          color="secondary"
        />
      </S.ShortCutCol>
    )}
  </>
);
